(function () {
  'use strict';
  function init(context) {
    context.querySelectorAll('[data-lp-stories]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      var track = root.querySelector('.lps-track');
      var cards = Array.from(root.querySelectorAll('.lps-card'));
      var prev = root.querySelector('[data-story-prev]');
      var next = root.querySelector('[data-story-next]');
      var count = root.querySelector('[data-story-count]');
      if (!cards.length) {root.hidden = true; return;}
      root.querySelector('.lps-nav').hidden = cards.length < 2;
      var index = 0;
      function update() {
        var left = track.getBoundingClientRect().left;
        index = cards.reduce(function (best, card, i) {
          return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? i : best;
        }, 0);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        count.textContent = (index + 1) + ' / ' + cards.length;
      }
      function move(direction) {
        var target = cards[Math.max(0, Math.min(cards.length - 1, index + direction))];
        track.scrollBy({left:target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', function () {move(-1);});
      next.addEventListener('click', function () {move(1);});
      track.addEventListener('keydown', function (e) {
        if (e.target !== track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1);}
      });
      track.addEventListener('scroll', update, {passive:true});
      if (typeof ResizeObserver !== 'undefined') {
        var observer = new ResizeObserver(update); observer.observe(track);
        document.addEventListener('shopify:section:unload', function unload(e) {
          if (e.target.contains(root)) {observer.disconnect(); document.removeEventListener('shopify:section:unload', unload);}
        });
      }
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        var overlay = card.querySelector('.lps-play');
        if (!video) return;
        video.controls = false;
        overlay.hidden = false;
        function play() {
          root.querySelectorAll('video').forEach(function (other) {if (other !== video) other.pause();});
          video.controls = true;
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {overlay.hidden = false;});
        }
        card.querySelectorAll('[data-story-play]').forEach(function (button) {button.addEventListener('click', play);});
        video.addEventListener('play', function () {overlay.hidden = true;});
        video.addEventListener('pause', function () {overlay.hidden = false;});
        video.addEventListener('ended', function () {overlay.hidden = false; video.controls = false;});
      });
      var drag = null, dragged = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('video[controls]')) return;
        drag = {id:e.pointerId,x:e.clientX,left:track.scrollLeft}; dragged = false;
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!dragged && Math.abs(dx) < 6) return;
        if (!dragged) track.setPointerCapture(e.pointerId);
        dragged = true; track.classList.add('is-dragging'); track.scrollLeft = drag.left - dx; e.preventDefault();
      });
      function endDrag() {drag = null; track.classList.remove('is-dragging');}
      track.addEventListener('pointerup', endDrag); track.addEventListener('pointercancel', endDrag); track.addEventListener('lostpointercapture', endDrag);
      track.addEventListener('pointerleave', function () {if (!dragged) drag = null;});
      track.addEventListener('click', function (e) {if (dragged) {e.preventDefault(); e.stopImmediatePropagation(); dragged = false;}}, true);
      track.addEventListener('dragstart', function (e) {e.preventDefault();});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {init(document);}); else init(document);
  document.addEventListener('shopify:section:load', function (e) {init(e.target);});
})();
